<template>
  <div>
    <Jumbotron title="How It Works?" />

    <!-- DESKTOP -->
    <b-container class="d-none d-sm-block">
      <b-row class="m-3 p-4">
        <b-col cols="10" offset="1" class="text-center">
          <video controls autoplay style="border-radius: 15px; max-width: 100%;">
            <source :src="require('@/assets/video/how-it-works.mp4')" type="video/mp4" >
          </video>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            Mau traveling tapi takut tidak mengenal tempat tujuan?
          </p>
          <p class="mt-3 text-justify">
            Memperkenalkan STARGUIDES
          </p>
          <p class="mt-3 text-justify">
            Aplikasi yang menghubungkan <i>traveller</i> dengan pelajar yang berada di luar negeri. Dengan STARGUIDES kamu tidak perlu takut lagi untuk jalan-jalan ke luar negeri karena Guider kami siap menemani kalian.
          </p>
          <p>
          <p class="mt-3 text-justify">
            Bagaimana caranya?
          </p>

          <p>
            <ol>
              <li>Kunjungi website STARGUIDES di <a href="https://www.starguides.co/">www.starguides.co</a> melalui laptop atau handphone kamu.</li>
              <li>Pilih kota tujuan, negara tujuan, tanggal perjalanan. Dan jangan lupa memilih jenis layanan sesuai dengan jumlah orang yang berangkat dan kebutuhanmu.</li>
              <li>Isi data peserta dengan lengkap.</li>
              <li>Lakukan pembayaran.</li>
              <li>Pembayaran dapat dilakukan dengan menggunakan <i>credit card</i> atau transfer ke <i>virtual account</i>.</li>
            </ol>
          </p>

          <p class="mt-3 text-justify">
            Setelah itu, STARGUIDES akan menghubungkan kamu dengan Guider yang cocok dengan pemesanan kamu. Pilih Guider yang sesuai dengan kebutuhan kamu. Kalian bisa berbincang dengan Guider melalui private chat room untuk berdiskusi lebbih lanjut.
          </p>
          <p class="mt-3 text-justify">
            Pada hari perjalanan, Guider akan menekan tombol 'Start' melalui aplikasi mereka sebagai tanda dimulainya perjalanan. Setelah itu, kalian bebas berjalan-jalan sesuai dengan rencana yang kalian tentukan.
          </p>
          <p class="mt-3 text-justify">
            Ketika perjalanan kalian selesai, Guider akan menekan tombol 'Stop' untuk mengakhiri perjalanan.
          </p>
          <p class="mt-3 text-justify">
            Ketika perjalanan kalian selesai, Guider akan menekan tombol 'Stop' untuk mengakhiri perjalanan. Jangan lupa memberikan rating dan review untuk guiders.
          </p>
          <p class="mt-3 text-justify">
            Yuk kita tentukan tanggalnya dari sekarang!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- MOBILE -->
    <b-container class="d-block d-sm-none">
      <b-row class="m-1 px-1 py-3">

        <b-col cols="12">
          <video controls autoplay style="border-radius: 15px; max-width: 100%;">
            <source :src="require('@/assets/video/how-it-works.mp4')" type="video/mp4" >
          </video>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            Mau traveling tapi takut tidak mengenal tempat tujuan?
          </p>
          <p class="mt-3 text-justify">
            Memperkenalkan STARGUIDES
          </p>
          <p class="mt-3 text-justify">
            Aplikasi yang menghubungkan <i>traveller</i> dengan pelajar yang berada di luar negeri. Dengan STARGUIDES kamu tidak perlu takut lagi untuk jalan-jalan ke luar negeri karena Guider kami siap menemani kalian.
          </p>
          <p>
          <p class="mt-3 text-justify">
            Bagaimana caranya?
          </p>

          <p>
            <ol>
              <li>Kunjungi website STARGUIDES di <a href="https://www.starguides.co/">www.starguides.co</a> melalui laptop atau handphone kamu.</li>
              <li>Pilih kota tujuan, negara tujuan, tanggal perjalanan. Dan jangan lupa memilih jenis layanan sesuai dengan jumlah orang yang berangkat dan kebutuhanmu.</li>
              <li>Isi data peserta dengan lengkap.</li>
              <li>Lakukan pembayaran.</li>
              <li>Pembayaran dapat dilakukan dengan menggunakan <i>credit card</i> atau transfer ke <i>virtual account</i>.</li>
            </ol>
          </p>

          <p class="mt-3 text-justify">
            Setelah itu, STARGUIDES akan menghubungkan kamu dengan Guider yang cocok dengan pemesanan kamu. Pilih Guider yang sesuai dengan kebutuhan kamu. Kalian bisa berbincang dengan Guider melalui private chat room untuk berdiskusi lebbih lanjut.
          </p>
          <p class="mt-3 text-justify">
            Pada hari perjalanan, Guider akan menekan tombol 'Start' melalui aplikasi mereka sebagai tanda dimulainya perjalanan. Setelah itu, kalian bebas berjalan-jalan sesuai dengan rencana yang kalian tentukan.
          </p>
          <p class="mt-3 text-justify">
            Ketika perjalanan kalian selesai, Guider akan menekan tombol 'Stop' untuk mengakhiri perjalanan.
          </p>
          <p class="mt-3 text-justify">
            Ketika perjalanan kalian selesai, Guider akan menekan tombol 'Stop' untuk mengakhiri perjalanan. Jangan lupa memberikan rating dan review untuk guiders.
          </p>
          <p class="mt-3 text-justify">
            Yuk kita tentukan tanggalnya dari sekarang!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'HowItWorks',
  components: {
    Jumbotron
  },
  data () {
    return {
      contents: [
        {
          img: 'icon-01.png',
          title: 'Pemesanan & Rencana',
          subtitle: 'Setelah melakukan pemesanan, Konsultasikan lah rute perjalanan kamu di Forum Chat dengan Guiders yang terpilih.'
        },
        {
          img: 'icon-02.png',
          title: 'Guiders Yang Terpilih',
          subtitle: 'Hore ! Kamu telah di jemput Guiders yang terpilih dan siap mengantar kamu pergi.'
        },
        {
          img: 'icon-03.png',
          title: 'Abadikan Momen!',
          subtitle: 'Yeay! Abadikan momen istimewamu bersama orang tersayang di tempat yang anda kunjungi.'
        },
        {
          img: 'icon-04.png',
          title: 'Waktunya Pulang',
          subtitle: 'Sampai di lain kesempatan & dan temukan guiders lain yang siap mengantar anda di perjalanan berikutnya.'
        },
        {
          img: 'icon-05.png',
          title: 'Review Guider',
          subtitle: 'Berikan review guiders sesuai kepuasan kamu.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.sg-title {
  font-weight: 900;
}
@media screen and (max-width: 767px) {
  .sg-title {
    font-size: 30px;
  }
}
@media screen and (max-width: 1023px) and (min-width: 768px) {
  .sg-title {
    font-size: 40px;
  }
}
@media screen and (max-width: 1980px) and (min-width: 1023px) {
  .sg-title {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Static/HowItWorks.vue